import { UserCrudService } from "../../apis/mgmt/UserCrudService";
import { User } from "../../apis/mgmt/api";
import { EditableProps, useStatefulApiEditable } from "../common/Editable";
import { ListProps } from "../common/List";
import { ToggleableProps, useStatefulToggleable } from "../common/Toggleable";
import { UserEditable } from "./UserEditable";
import { UserFilteredList, useUserFilteredPaginated } from "./UserFilteredList";
import { UserPageLayout } from "./UserPageLayout";

export function useUserPage(props: {
    listProps: ListProps<User>,
    toggle: ToggleableProps,
    editableProps: EditableProps<User>,
    defaultAddItemData?: User
}) {


    const { listProps, toggle, editableProps } = props;

    listProps.onAddItem = () => {
        editableProps.edit(props.defaultAddItemData);
        toggle.show();
    };

    listProps.onEditItem = (item: User) => {
        editableProps.edit(item);
        toggle.show();
    };

    editableProps.onSaved = (item: User, hideAfterSaving: boolean) => {
        listProps.setItem(item);
        if (hideAfterSaving) toggle.hide();
    };

    editableProps.onDeleted = (item: User) => {
        listProps.deleteItem(item);
        toggle.hide();
    };

    return props;
}

export const UserPage = function () {

    const { filterProps, listProps, pagingProps} = useUserFilteredPaginated();

    const toggle = useStatefulToggleable(false);
    const editableProps = useStatefulApiEditable(UserCrudService, undefined, undefined, toggle);

    useUserPage({ listProps, editableProps, toggle });

    return (
        <UserPageLayout
            list={<UserFilteredList {...{ filterProps, listProps, pagingProps }} />}
            toggle={toggle}
            detailForm={<UserEditable {...editableProps} />}
        />
    );

};
